import { Accordion } from "react-bootstrap";
import { useState } from "react";
import moment from 'moment';
import { useSelector } from "react-redux";

const SchemeLedgerOverlay = ({
    toggleAccordion, 
    activeKeys, 
    ledgerOverlay, 
    fy_list,
    globalDateId,
    setLedgerOverlay,
    setOverlay,
    setOverlayDropDown,
    overlayDropDown,
    schemeDetails,
    schemeBudgetList,
    schemeInvoiceList,
    schemeReimbursementList,
    schemeAllocationList,
    schemeAllocatedToMeList,
    budgetReappropriationList,
    schemeSalaryList,
    surrenderAcceptedList,
    surrenderDoneList
}) => {
  const {authData} =  useSelector((state) => state.authData);
  const [activeCard, setActiveCard] = useState([]);
  const [ledSubHeadAccordion, setledSubHeadAccordion] = useState([]);
    const storedGlobalDateId = localStorage.getItem("globalDateId");
  const subheadAccordianSwitch = (subheadId) => {
    setledSubHeadAccordion((prev) => {
      if (prev.includes(subheadId)) {
        return prev.filter((id) => id !== subheadId);
      } else {
        return [...prev, subheadId];
      }
    });
  };

  const mainCardSwitch = (val1, val2, val3, detailObj) => {
    setActiveCard((prev) => {
      let updated = [...prev];
      updated = updated.filter(item => item !== val2 && item !== val3);
      if (!updated.includes(val1)) {
        updated.unshift(val1);
      }
      return updated;
    });
  };

  function shortActivitiesFromSubhead(activities) {
    let activityArr = [];
    activities?.forEach(e => {
      if(activityArr.length) {
        let valueAdded = false;
        activityArr.forEach(f => {
          if(f.activityId === e.subhead_activity_id) {
            valueAdded = true;
            f.budgetGet += Number(e.budget_get)
            f.budget += Number(e.budget)
            f.provisional_budget += Number(f.provisional_budget)
            f.prev_balance += Number(e.prev_balance)
          }
        });
        if(!valueAdded) {
          activityArr.push(
            {
              activityName: e.activity, 
              activityId: e.subhead_activity_id, 
              budgetGet: Number(e.budget_get), 
              budget: Number(e.budget), 
              provisional_budget: Number(e.provisional_budget), 
              prev_balance: Number(e.prev_balance)
            }
          )
        }
      }else{
        activityArr.push({activityName: e.activity, activityId: e.subhead_activity_id, budgetGet: Number(e.budget_get), budget: Number(e.budget), provisional_budget: Number(e.provisional_budget), prev_balance: Number(e.prev_balance)})
      }
    });
    return activityArr;
  }

  const getYears = (fy_id) => {
    const fiscalYear = fy_list.find((fy) => fy.id === fy_id);
    return fiscalYear ? fiscalYear.start_year + '-' + fiscalYear.end_year : "-";
  }

    return (
        <div
        className={`overlayContent overflow-auto ${
          ledgerOverlay ? "left-100" : null
        } `}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-secondary-100 position-sticky top-0 position-relative text-white d-flex justify-content-between align-items-center ps-4">
          <div className="fw-600 fs-16px d-flex align-items-center gap-2 ">
            <i
              className="icon-close_circle_fill fs-5  cursor-pointer"
              onClick={() => setLedgerOverlay(true)}
            ></i>
            Scheme Ledger
          </div>

          <div className="d-flex gap-2 align-items-center h-100 py-3 position-relative pe-4">
            <span>As on date {" "}
              {
                              <select
                                name="financial_year_id"
                                className="bg-transparent border-0 text-white fw-500 fs-16px select"
                                disabled
                              >
                                <option value="" className="text-black">
                                  select year
                                </option>
                                {fy_list?.map((fy) => {
                                  return (
                                    <option
                                      value={storedGlobalDateId}
                                      key={fy.id}
                                      className="text-black"
                                      selected={
                                        String(fy.id) === storedGlobalDateId || (!storedGlobalDateId && fy.start_year === moment().format("YYYY"))
                                      }
                                    >
                                      {fy.start_year.includes(new Date().getFullYear()) 
                                        ? moment().format("Do MMM YYYY")
                                        : "31 Mar " + fy.end_year}
                                    </option>
                                  );
                                })}
                              </select>
                            }

            </span>
            <i
              className="icon-arrow_drop_down_circle fs-18px cursor-pointer"
              onClick={() => setOverlayDropDown((prev) => !prev)}
            ></i>

            <div
              className={`position-absolute bg-prime-100 w-100 p-3 ${
                !overlayDropDown ? "d-none" : "d-inline-block"
              }`}
              style={{ top: "100%", zIndex: "10" }}
            >
              <div className="d-flex flex-column gap-4">
                <span className="d-flex align-items-center gap-2 cursor-pointer">
                  <i className="icon-picture_as_pdf"></i> Export PDF
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="py-2 px-4">
          <div className="m-0 p-0">
            <div
              className="bg-white border-Prime-100 my-2 p-0"
              style={{ borderRadius: "8px" }}
            >
              <div
                className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden "
                style={{ borderRadius: "8px 8px 0 0" }}
              >
                {/* ======================card header================== */}
                <span
                  className="fs-14px white-space-nowrap overflow-x-hidden d-flex justify-content-between align-items-center gap-2 p-0 m-0 w-100"
                  style={{ width: "95%", fontStyle: "italic" }}
                >
                  {/* =======================card header====================== */}
                  <span
                    className="fs-14px white-space-nowrap overflow-x-hidden"
                    style={{ width: "95%", fontStyle: "italic" }}
                  >
                    <span className="fw-500 text-secondary-100">
                      Scheme Id {schemeDetails.code}-{schemeDetails?.name}
                    </span>
                  </span>
                  <span className="d-flex gap-2 p-0 m-0 justify-self-end align-items-center">
                    <i
                      className="icon-remove_red_eye cursor-pointer"
                      onClick={() => setOverlay(false)}
                    ></i>
                    <i
                      className="icon-account_balance_wallet cursor-pointer"
                      onClick={() => setLedgerOverlay(false)}
                    ></i>
                  </span>
                </span>
              </div>

              {/* ================== card body ========================= */}

              <div className="row py-2 px-3">
                <div className="row">
                  <div className="d-flex justify-content-between align-items-center gap-3">
                    <div
                      className="d-flex justify-content-between align-items-center py-2 px-1 border rounded-1 "
                      style={{ flexGrow: "2" }}
                    >
                      <span className="text-black-60 fs-12px">
                        <span className="me-2">Provisional Budget</span>
                        {fy_list?.map((val, ind) => {
                          return val?.id == globalDateId && val?.year;
                        })}
                      </span>
                      <span className="fw-500 fs-14px">{Number(schemeDetails.total_provisional_budget).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</span>
                    </div>
                    <div
                      className="d-flex flex-column justify-content-center py-2"
                      style={{ flexGrow: "1" }}
                    >
                      <div className="d-flex gap-2 justify-content-between align-items-center">
                        <span className="text-black-60 fs-12px">
                          Released FY{" "}
                          {fy_list?.map((val, ind) => {
                            return val?.id == globalDateId && val?.year;
                          })}
                        </span>
                        <i className="icon-launch text-link"></i>
                      </div>
                      <span className="fw-500 fs-14px">{Number(schemeDetails.total_budget)?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</span>
                    </div>
                    <div
                      className="d-flex flex-column justify-content-center py-2"
                      style={{ flexGrow: "1" }}
                    >
                      <div className="d-flex gap-2 justify-content-between align-items-center">
                        <span className="text-black-60 fs-12px">
                          Previous FY Balance (Opening)
                        </span>
                        <i className="icon-info"></i>
                      </div>
                      <span className="fw-500 fs-14px">{Number(schemeDetails.prevYearBalance).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</span>
                    </div>
                    <div
                      className="d-flex flex-column justify-content-center py-2"
                      style={{ flexGrow: "1" }}
                    >
                      <div className="d-flex gap-2 justify-content-between align-items-center">
                        <span className="text-black-60 fs-12px">
                          Total Balance (Opening)
                        </span>
                        <i className="icon-info"></i>
                      </div>
                      <span className="fw-500 fs-14px text-success-100">
                        {(Number(schemeDetails.total_budget) + Number(schemeDetails.prevYearBalance)).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                      </span>
                    </div>
                  </div>

                  <div className="col-3 d-flex flex-column justify-content-center py-2">
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="text-black-60 fs-12px">
                        Under approval
                      </span>
                      <i className="icon-launch text-link"></i>
                    </div>
                    <span className="fw-500 fs-14px">{Number(schemeDetails.pending_budget).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</span>
                  </div>
                  <div className="col-3 d-flex flex-column justify-content-center py-2">
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="text-black-60 fs-12px">Sanction</span>
                      <i className="icon-launch text-link"></i>
                    </div>
                    <span className="fw-500 fs-14px">{Number(schemeDetails.utilised_budget).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</span>
                  </div>
                  <div className="col-3 d-flex flex-column m-0 justify-content-center py-2 px-1 ">
                    <div className="d-flex p-0 m-0 justify-content-between align-items-center ">
                      <span className="text-black-60 fs-12px">
                        Previous FY Balance (Closing)
                      </span>
                      <i className="icon-info"></i>
                    </div>
                    <span className="fw-500 fs-14px">{Number(schemeDetails.prev_year_pending_balance).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</span>
                  </div>
                  <div className="col-3 d-flex flex-column justify-content-center py-2 bg-success-20">
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="text-black-60 fs-12px">
                        Total Balance (Closing)
                      </span>
                      <i className="icon-info"></i>
                    </div>
                    <span className="fw-500 fs-14px text-success-100">
                      {schemeDetails.balance}
                    </span>
                  </div>
                </div>

                <div>
                  {/* =======================buttons ====================== */}
                  <hr className="my-2" />

                  <div className="pb-2 d-flex justify-content-between text-secondary-50">
                    <button
                      onClick={() => mainCardSwitch(`subhead_${schemeDetails.id}`, `activity_${schemeDetails.id}`, `subactivity_${schemeDetails.id}`, {scheme_id: schemeDetails.id, subhead: true, activity: false, subActivity: false})}
                      className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1 rounded-4 ${
                        activeCard == 1 ? "bg-secondary-20" : "bg-white"
                      } `}
                    >
                      {activeCard == 1 ? (
                        <i className="icon-remove_circle_outline"></i>
                      ) : (
                        <i className="icon-add_circle_outline"></i>
                      )}
                      Sub head
                    </button>
                    <button
                      onClick={() => mainCardSwitch(`activity_${schemeDetails.id}`, `subhead_${schemeDetails.id}`, `subactivity_${schemeDetails.id}`, {scheme_id: schemeDetails.id, subhead: true, activity: false, subActivity: false})}
                      className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4 ${
                        activeCard == 2 ? "bg-secondary-20" : "bg-white"
                      } `}
                    >
                      {activeCard == 2 ? (
                        <i className="icon-remove_circle_outline"></i>
                      ) : (
                        <i className="icon-add_circle_outline"></i>
                      )}
                      Activity
                    </button>
                    {/* <button
                      onClick={() => mainCardSwitch(`subactivity_${schemeDetails.id}`, `activity_${schemeDetails.id}`, `subhead_${schemeDetails.id}`, {scheme_id: schemeDetails.id, subhead: true, activity: false, subActivity: false})}
                      className={` ${
                        activeCard == 3 ? "bg-secondary-20" : "bg-white"
                      } 
                  border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4`}
                    >
                      {activeCard == 3 ? (
                        <i className="icon-remove_circle_outline"></i>
                      ) : (
                        <i className="icon-add_circle_outline"></i>
                      )}
                      Sub-Activity
                    </button> */}
                  </div>

                  {/* ===============================child datas============================== */}

                  {activeCard.includes(`subhead_${schemeDetails.id}`) && (
                    <div className="subhead" key={schemeDetails.id}>
                      <div className="row">
                        <div className="row pt-2 m-0">
                          <div className="col-3 d-flex justify-content-between align-items-center">
                            <span className="text-black-60 fs-12px">
                              Subhead Name
                            </span>
                          </div>
                          <div className="col-3 d-flex justify-content-between align-items-center">
                            <span className="text-black-60 fs-12px">
                              FY{" "}
                              {fy_list?.map((val, ind) => {
                                return val?.id == globalDateId && val?.year;
                              })}
                            </span>
                          </div>
                          <div className="col-3 d-flex justify-content-between align-items-center">
                            <span className="text-black-60 fs-12px">
                              Previous FY Balance
                            </span>
                            <i className="icon-info"></i>
                          </div>
                          <div className="col-3 d-flex justify-content-between align-items-center">
                            <span className="text-black-60 fs-12px">Total</span>
                          </div>
                        </div>
                        {/* ===================================values================================= */}
                        {
                          schemeDetails.sub_head_list?.map((subhead, index) => (
                            <div className="row pb-2 m-0" key={index}>
                              <div className="col-3 d-flex align-items-center">
                                {ledSubHeadAccordion?.includes(subhead.id) ? (
                                  <i
                                    className="icon-keyboard_arrow_down cursor-pointer"
                                    onClick={() => subheadAccordianSwitch(subhead.id)}
                                  ></i>
                                ) : (
                                  <i
                                    className="icon-keyboard_arrow_right cursor-pointer"
                                    onClick={() => subheadAccordianSwitch(subhead.id)}
                                  ></i>
                                )}
                                <span className="fs-14px fw-500">{subhead.name}</span>
                              </div>
                              <div className="col-3 d-flex justify-content-between align-items-center">
                                <span className="fs-14px fw-500">
                                  {subhead.budget.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                </span>
                              </div>
                              <div className="col-3 d-flex justify-content-between align-items-center">
                                <span className="fs-14px fw-500">
                                  {subhead.pervious_year_budget.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                </span>
                              </div>
                              <div className="col-3 d-flex justify-content-between align-items-center">
                                <span className="fs-14px fw-500 text-success-100">
                                  {(Number(subhead.budget) + Number(subhead.pervious_year_budget)).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                </span>
                              </div>

                              {/* ==============================sub data========================== */}

                              {ledSubHeadAccordion?.includes(subhead.id) && (
                                <>
                                  <div>
                                    <h3 className="fw-600 fs-18px my-2">
                                      Receipt (Inflow)
                                    </h3>

                                    <div className=" pb-2 d-flex flex-column gap-1 mt-2">
                                      <Accordion
                                        activeKey={activeKeys}
                                        style={{ border: "0" }}
                                      >
                                        <Accordion.Item
                                          eventKey={`budget_${subhead.id}`}
                                          style={{ borderRadius: "0", border: "0" }}
                                        >
                                          <Accordion.Header
                                            onClick={() => toggleAccordion(`budget_${subhead.id}`)}
                                          >
                                            <div className="w-100 d-flex justify-content-between">
                                              <span>Budget</span>
                                              <span
                                                className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                style={{
                                                  height: "13.33px",
                                                  width: "13.33px",
                                                }}
                                              >
                                                {activeKeys.includes(`budget_${subhead.id}`)
                                                  ? "-"
                                                  : "+"}
                                              </span>
                                            </div>
                                          </Accordion.Header>
                                          <Accordion.Body>
                                            <div>
                                              {
                                                <div className="row my-1 p-0 mx-0">
                                                  <div className="row m-0 px-0">
                                                    <div className="col-1 fs-12px text-black-60">
                                                      S.No.
                                                    </div>
                                                    <div className="col-4 fs-12px text-black-60">
                                                      Order No.
                                                    </div>
                                                    <div className="col-2 fs-12px text-black-60">
                                                      Order Date
                                                    </div>
                                                    <div className="col-3 fs-12px text-black-60">
                                                      Provision Budget
                                                    </div>
                                                    <div className="col-2 fs-12px text-black-60">
                                                      Released Budget
                                                    </div>
                                                  </div>
                                                  {schemeBudgetList
                                                    .filter(budget => budget.subhead_id === subhead.id && budget.is_budget_allocated !== "1" && budget.l2_status === "1" && budget.l3_status === "1")
                                                    .map((budget, idx) => (
                                                      <div key={budget.id || idx} className="row mt-1 m-0 px-0">
                                                        <div className="col-1 fs-14px fw-500">
                                                          {idx + 1}
                                                        </div>
                                                        <div className="col-4 fs-14px fw-500">
                                                          {budget.budget_order_no}
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500">
                                                          {moment(budget.budget_order_date, 'YYYY-MM-DD').format("DD-MM-YYYY")}
                                                        </div>
                                                        <div className="col-3 fs-14px fw-500">
                                                          {budget.subhead_provisional_budget.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500 text-success-100">
                                                          {budget.budget.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                        </div>
                                                      </div>
                                                    ))
                                                  }
                                                  
                                                  {/* =================== total row value ============== */}
                                                  {(() => {
                                                    const filteredBudgets = schemeBudgetList.filter(b => b.subhead_id === subhead.id && b.is_budget_allocated !== "1" && b.l2_status === "1" && b.l3_status === "1");

                                                    const totals = filteredBudgets.reduce(
                                                      (acc, curr) => {
                                                        acc.budget += Number(curr.budget || 0);
                                                        acc.provisional_budget += Number(curr.subhead_provisional_budget || 0);
                                                        return acc;
                                                      },
                                                      { budget: 0, provisional_budget: 0 }
                                                    );

                                                    return (
                                                      <div className="row bg-info-20 py-1 px-0 m-0">
                                                        <div className="col-1 fs-14px fw-500 text-prime-100">
                                                          Total
                                                        </div>
                                                        <div className="col-4 fs-14px fw-500">
                                                          {/* Optional empty or additional text */}
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500">
                                                          
                                                        </div>
                                                        <div className="col-3 fs-14px fw-500">
                                                          {totals.provisional_budget.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500 text-success-100">
                                                          {totals.budget.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                        </div>
                                                      </div>
                                                    );
                                                  })()}
                                                </div>
                                              }
                                            </div>
                                          </Accordion.Body>
                                        </Accordion.Item>
                                      </Accordion>
                                      {
                                        authData.user.department_details.is_multi === "1" && 
                                        <Accordion
                                        activeKey={activeKeys}
                                        style={{ border: "0" }}
                                        >
                                          <Accordion.Item
                                            eventKey="11"
                                            style={{ borderRadius: "0", border: "0" }}
                                          >
                                            <Accordion.Header
                                              onClick={() => toggleAccordion("11")}
                                            >
                                              <div className="w-100 d-flex justify-content-between">
                                                <span>Budget Allocation</span>
                                                <span
                                                  className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                  style={{
                                                    height: "13.33px",
                                                    width: "13.33px",
                                                  }}
                                                >
                                                  {activeKeys.includes("11")
                                                    ? "-"
                                                    : "+"}
                                                </span>
                                              </div>
                                            </Accordion.Header>

                                            <Accordion.Body>
                                              <div>
                                                {
                                                  <div className="row my-1 mx-0">
                                                    <div className="row m-0 px-0">
                                                      <div className="col-1 fs-12px text-black-60">
                                                        Sr.
                                                      </div>
                                                      <div className="col-3 fs-12px text-black-60">
                                                        Order No.
                                                      </div>
                                                      <div className="col-3 fs-12px text-black-60">
                                                        Order Date
                                                      </div>
                                                      <div className="col-3 fs-12px text-black-60">
                                                        Provision Budget
                                                      </div>
                                                      <div className="col-2 fs-12px text-black-60">
                                                        Released Budget
                                                      </div>
                                                    </div>

                                                    {
                                                      schemeAllocatedToMeList?.filter(allocation => allocation.subhead_id === subhead.id).map((allocation, idx) => (
                                                        <div className="row mt-1 m-0 px-0" key={idx}>
                                                          <div className="col-1 fs-14px fw-500">
                                                            {idx + 1}
                                                          </div>
                                                          <div className="col-3 fs-14px fw-500">
                                                            {allocation?.budget_order_no}
                                                          </div>
                                                          <div className="col-3 fs-14px fw-500">
                                                            {allocation?.budget_order_date}
                                                          </div>
                                                          <div className="col-3 fs-14px fw-500">
                                                            {Number(allocation?.subhead_provisional_budget).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                          </div>
                                                          <div className="col-2 fs-14px fw-500">
                                                            {Number(allocation?.subhead_budget).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                          </div>
                                                        </div>
                                                      ))
                                                    }
                                                    
                                                    {/* =================== total row value ============== */}
                                                    {(() => {
                                                      const filteredBudgets = schemeAllocatedToMeList?.filter(b => b.subhead_id === subhead.id);

                                                      const totals = filteredBudgets.reduce(
                                                        (acc, curr) => {
                                                          acc.subhead_provisional_budget += Number(curr.subhead_provisional_budget || 0);
                                                          acc.subhead_budget += Number(curr.subhead_budget || 0);
                                                          return acc;
                                                        },
                                                        { subhead_provisional_budget: 0, subhead_budget: 0 }
                                                      );

                                                      return (
                                                        <div className="row bg-info-20 py-1 px-0 m-0">
                                                          <div className="col-1 fs-14px fw-500 text-prime-100">
                                                            Total
                                                          </div>
                                                          <div className="col-3 fs-14px fw-500">
                                                            
                                                          </div>
                                                          <div className="col-3 fs-14px fw-500">
                                                            
                                                          </div>
                                                          <div className="col-3 fs-14px fw-500">
                                                            {totals.subhead_provisional_budget.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                          </div>
                                                          <div className="col-2 fs-14px fw-500 text-success-100">
                                                            {totals.subhead_budget.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                          </div>
                                                        </div>
                                                      );
                                                    })()}
                                                  </div>
                                                }
                                              </div>
                                            </Accordion.Body>
                                          </Accordion.Item>
                                        </Accordion>
                                      }
                                      

                                      <Accordion
                                        activeKey={activeKeys}
                                        style={{ border: "0" }}
                                      >
                                        <Accordion.Item
                                          eventKey="100"
                                          style={{ borderRadius: "0", border: "0" }}
                                        >
                                          <Accordion.Header
                                            onClick={() => toggleAccordion("100")}
                                          >
                                            <div className="w-100 d-flex justify-content-between">
                                              <span>Budget Repropregation</span>
                                              <span
                                                className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                style={{
                                                  height: "13.33px",
                                                  width: "13.33px",
                                                }}
                                              >
                                                {activeKeys.includes("100")
                                                  ? "-"
                                                  : "+"}
                                              </span>
                                            </div>
                                          </Accordion.Header>

                                          <Accordion.Body>
                                            <div>
                                              
                                                <div className="row my-1 mx-0">
                                                  <div className="row m-0 px-0">
                                                    <div className="col-3 fs-12px text-black-60">
                                                      Sr.
                                                    </div>
                                                    <div className="col-3 fs-12px text-black-60">
                                                      Order No.
                                                    </div>
                                                    <div className="col-3 fs-12px text-black-60">
                                                      Order Date
                                                    </div>
                                                    <div className="col-3 fs-12px text-black-60">
                                                      Released Budget
                                                    </div>
                                                  </div>
                                                  {
                                                    budgetReappropriationList.filter(reprop => reprop.to_subhead_id === subhead.id).map((reprop, idx) => (
                                                      <div className="row mt-1 m-0 px-0" key={idx}>
                                                        <div className="col-3 fs-14px fw-500">
                                                          {idx + 1}
                                                        </div>
                                                        <div className="col-3 fs-14px fw-500">
                                                          {reprop.order_no}
                                                        </div>
                                                        <div className="col-3 fs-14px fw-500">
                                                          {reprop.order_date}
                                                        </div>
                                                        <div className="col-3 fs-14px fw-500">
                                                          {reprop.reappropriation_amount}
                                                        </div>
                                                      </div>
                                                    ))
                                                  }
                                                  {/* =================== total row value ============== */}
                                                  {(() => {
                                                    const filteredBudgets = budgetReappropriationList.filter(b => b.to_subhead_id === subhead.id);

                                                    const totals = filteredBudgets.reduce(
                                                      (acc, curr) => {
                                                        acc.reappropriation_amount += Number(curr.reappropriation_amount || 0);
                                                        return acc;
                                                      },
                                                      { reappropriation_amount: 0 }
                                                    );

                                                    return (
                                                      <div className="row bg-info-20 py-1 px-0 m-0">
                                                        <div className="col-3 fs-14px fw-500 text-prime-100">
                                                          Total
                                                        </div>
                                                        <div className="col-3 fs-14px fw-500">
                                                          
                                                        </div>
                                                        <div className="col-3 fs-14px fw-500">
                                                          
                                                        </div>
                                                        <div className="col-3 fs-14px fw-500 text-success-100">
                                                            {totals.reappropriation_amount.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                        </div>
                                                      </div>
                                                    );
                                                  })()}
                                                  
                                                </div>
                                              
                                            </div>
                                          </Accordion.Body>
                                        </Accordion.Item>
                                      </Accordion>

                                      <Accordion
                                        activeKey={activeKeys}
                                        style={{ border: "0" }}
                                      >
                                        <Accordion.Item
                                          eventKey={`surredner_accepted_${subhead.id}`}
                                          style={{ borderRadius: "0", border: "0" }}
                                        >
                                          <Accordion.Header
                                            onClick={() => toggleAccordion(`surredner_accepted_${subhead.id}`)}
                                          >
                                            <div className="w-100 d-flex justify-content-between">
                                              <span>Budget Surrender Accepted</span>
                                              <span
                                                className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                style={{
                                                  height: "13.33px",
                                                  width: "13.33px",
                                                }}
                                              >
                                                {activeKeys.includes("100")
                                                  ? "-"
                                                  : "+"}
                                              </span>
                                            </div>
                                          </Accordion.Header>

                                          <Accordion.Body>
                                            <div>
                                              
                                                <div className="row my-1 mx-0">
                                                  <div className="row m-0 px-0">
                                                    <div className="col-2 fs-12px text-black-60">
                                                      Sr.
                                                    </div>
                                                    <div className="col-3 fs-12px text-black-60">
                                                      Order No.
                                                    </div>
                                                    <div className="col-2 fs-12px text-black-60">
                                                      Order Date
                                                    </div>
                                                    <div className="col-3 fs-12px text-black-60">
                                                      Surrender Done By
                                                    </div>
                                                    <div className="col-2 fs-12px text-black-60">
                                                      Amount
                                                    </div>
                                                  </div>

                                                  {
                                                    surrenderAcceptedList.filter(e => e.subhead_id == subhead.id).map((surrender, sIndex) => (
                                                      <div className="row mt-1 m-0 px-0" key={sIndex}>
                                                        <div className="col-2 fs-14px fw-500">
                                                          {sIndex + 1}
                                                        </div>
                                                        <div className="col-3 fs-14px fw-500">
                                                          {surrender.order_no}
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500">
                                                          {surrender.order_date}
                                                        </div>
                                                        <div className="col-3 fs-14px fw-500">
                                                          {surrender.name}
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500">
                                                          {surrender.amount}
                                                        </div>
                                                      </div>
                                                    ))
                                                  }

                                                  {/* =================== total row value ============== */}
                                                  {(() => {
                                                    const filteredBudgets = surrenderAcceptedList.filter(b => b.subhead_id === subhead.id);

                                                    const totals = filteredBudgets.reduce(
                                                      (acc, curr) => {
                                                        acc.amount += Number(curr.amount || 0);
                                                        return acc;
                                                      },
                                                      { amount: 0 }
                                                    );

                                                    return (
                                                      <div className="row bg-info-20 py-1 px-0 m-0">
                                                        <div className="col-2 fs-14px fw-500 text-prime-100">
                                                          Total
                                                        </div>
                                                        <div className="col-3 fs-14px fw-500">
                                                          
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500">
                                                          
                                                        </div>
                                                        <div className="col-3 fs-14px fw-500">
                                                          
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500 text-success-100">
                                                            {totals.amount.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                        </div>
                                                      </div>
                                                    );
                                                  })()}
                                                  
                                                </div>
                                              
                                            </div>
                                          </Accordion.Body>
                                        </Accordion.Item>
                                      </Accordion>

                                      
                                    </div>
                                  </div>

                                  <div>
                                    <h3 className="fw-600 fs-18px my-2">
                                      Payment (Outflow)
                                    </h3>

                                    <div className=" py-1 d-flex flex-column gap-1 mt-2">
                                      {/* vendor list */}
                                      <Accordion
                                        activeKey={activeKeys}
                                        style={{ border: "0" }}
                                      >
                                        <Accordion.Item
                                          eventKey={`subhead_invoice_${subhead.id}`}
                                          style={{ borderRadius: "0", border: "0" }}
                                        >
                                          <Accordion.Header
                                            onClick={() => toggleAccordion(`subhead_invoice_${subhead.id}`)}
                                          >
                                            <div className="w-100 d-flex justify-content-between">
                                              <span>Vendor</span>
                                              <span
                                                className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                style={{
                                                  height: "13.33px",
                                                  width: "13.33px",
                                                }}
                                              >
                                                {activeKeys.includes(`subhead_invoice_${subhead.id}`)
                                                  ? "-"
                                                  : "+"}
                                              </span>
                                            </div>
                                          </Accordion.Header>

                                          <Accordion.Body>
                                            <div>
                                              {
                                                <div className="row my-1 mx-0">
                                                  <div className="row m-0 px-0">
                                                    <div className="col-1 fs-12px text-black-60">
                                                      S.No.
                                                    </div>
                                                    <div className="col-2 fs-12px text-black-60">
                                                      Financial Year
                                                    </div>
                                                    <div className="col-2 fs-12px text-black-60">
                                                      Vendor
                                                    </div>
                                                    <div className="col-2 fs-12px text-black-60">
                                                      Invoice / Date
                                                    </div>
                                                    <div className="col-3 fs-12px text-black-60">
                                                      Sanctioned Order / Date
                                                    </div>
                                                    <div className="col-1 fs-12px text-black-60">
                                                      Invoice Amount
                                                    </div>
                                                    <div className="col-1 fs-12px text-black-60">
                                                      Sanctioned Amount
                                                    </div>
                                                  </div>
                                                  {
                                                    schemeInvoiceList.filter(invoice => invoice.subhead_id === subhead.id).map((invoice, idx) => (
                                                      <div className="row mt-1 m-0 px-0" key={idx}>
                                                        <div className="col-1 fs-14px fw-500">
                                                          {idx + 1}
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500">
                                                          {invoice.start_year} - {invoice.end_year}
                                                        </div>
                                                         <div className="col-2 fs-14px fw-500">
                                                          {invoice.company_name}
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500">
                                                          {invoice.invoice_no} | {invoice.invoice_date}
                                                        </div>
                                                        <div className="col-3 fs-14px fw-500">
                                                          {invoice.sanction_order_no} | {invoice.sanction_order_date}
                                                        </div>
                                                        <div className="col-1 fs-14px fw-500" style={{textAlign: 'right'}}>
                                                          {Number(invoice.invoice_value).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                        </div>
                                                        <div className="col-1 fs-14px fw-500" style={{textAlign: 'right'}}>
                                                          {Number(invoice.subhead_amount).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                        </div>
                                                      </div>
                                                    ))
                                                  }
                                                  
                                                  {/* =================== total row value ============== */}
                                                  {(() => {
                                                    const filteredBudgets = schemeInvoiceList.filter(b => b.subhead_id === subhead.id);

                                                    const totals = filteredBudgets.reduce(
                                                      (acc, curr) => {
                                                        acc.invoice_value += Number(curr.invoice_value || 0);
                                                        acc.subhead_amount += Number(curr.subhead_amount || 0);
                                                        return acc;
                                                      },
                                                      { invoice_value: 0, subhead_amount: 0 }
                                                    );

                                                    return (
                                                      <div className="row bg-info-20 py-1 px-0 m-0">
                                                        <div className="col-1 fs-14px fw-500 text-prime-100">
                                                          Total
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500 m-0">
                                                          
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500">
                                                          
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500 text-success-100">
                                                          
                                                        </div>
                                                        <div className="col-3 fs-14px fw-500">
                                                          
                                                        </div>
                                                        <div className="col-1 fs-14px fw-500 text-success-100">
                                                          {totals.invoice_value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                        </div>
                                                        <div className="col-1 fs-14px fw-500 text-success-100">
                                                          {totals.subhead_amount.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                        </div>
                                                      </div>
                                                    );
                                                  })()}
                                                </div>
                                              }
                                            </div>
                                          </Accordion.Body>
                                        </Accordion.Item>
                                      </Accordion>
                                      {/* DBT List */}
                                      <Accordion
                                        activeKey={activeKeys}
                                        style={{ border: "0" }}
                                      >
                                        <Accordion.Item
                                          eventKey={`subhead_reimbursement_${subhead.id}`}
                                          style={{ borderRadius: "0", border: "0" }}
                                        >
                                          <Accordion.Header
                                            onClick={() => toggleAccordion(`subhead_reimbursement_${subhead.id}`)}
                                          >
                                            <div className="w-100 d-flex justify-content-between">
                                              <span>DBT/NACH</span>
                                              <span
                                                className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                style={{
                                                  height: "13.33px",
                                                  width: "13.33px",
                                                }}
                                              >
                                                {activeKeys.includes(`subhead_reimbursement_${subhead.id}`)
                                                  ? "-"
                                                  : "+"}
                                              </span>
                                            </div>
                                          </Accordion.Header>

                                          <Accordion.Body>
                                            <div>
                                              {
                                                <div className="row my-1 mx-0">
                                                  <div className="row m-0 px-0">
                                                    <div className="col fs-12px text-black-60">
                                                      Sr.
                                                    </div>
                                                    <div className="col fs-12px text-black-60">
                                                      Department Level/Name
                                                    </div>
                                                    <div className="col fs-12px text-black-60">
                                                      Order Date
                                                    </div>
                                                    <div className="col fs-12px text-black-60">
                                                      Sanction Amount
                                                    </div>
                                                    <div className="col fs-12px text-black-60">
                                                      Deduction Amount
                                                    </div>
                                                    <div className="col fs-12px text-black-60">
                                                      Payment Amount
                                                    </div>
                                                  </div>
                                                  {
                                                    schemeReimbursementList?.filter(reimbursement => reimbursement.subhead_id === subhead.id).map((reimbursement, idx) => (
                                                      <div className="row mt-1 m-0 px-0" key={idx}>
                                                        <div className="col fs-14px fw-500">
                                                          {idx + 1}
                                                        </div>
                                                        <div className="col fs-14px fw-500">
                                                          {reimbursement?.department_name}
                                                        </div>
                                                        <div className="col fs-14px fw-500">
                                                          {reimbursement?.reimbursement_order_date}
                                                        </div>
                                                        <div className="col fs-14px fw-500">
                                                          {reimbursement?.reimbursement_order_value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                        </div>
                                                        <div className="col fs-14px fw-500">
                                                         0
                                                        </div>
                                                        <div className="col fs-14px fw-500">
                                                          {reimbursement?.reimbursement_order_value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                        </div>
                                                      </div>
                                                    ))
                                                  }
                                                  
                                                  {/* =================== total row value ============== */}
                                                  {(() => {
                                                    const filteredBudgets = schemeReimbursementList?.filter(b => b.subhead_id === subhead.id);

                                                    const totals = filteredBudgets.reduce(
                                                      (acc, curr) => {
                                                        acc.reimbursement_order_value += Number(curr.reimbursement_order_value || 0);
                                                        return acc;
                                                      },
                                                      { reimbursement_order_value: 0 }
                                                    );

                                                    return (
                                                      <div className="row bg-info-20 py-1 px-0 m-0">
                                                        <div className="col fs-14px fw-500 text-prime-100">
                                                          Total
                                                        </div>
                                                        <div className="col fs-14px fw-500 m-0">
                                                         
                                                        </div>
                                                        <div className="col fs-14px fw-500">
                                                          
                                                        </div>
                                                        <div className="col fs-14px fw-500">
                                                          
                                                        </div>
                                                        <div className="col fs-14px fw-500">
                                                          
                                                        </div>
                                                        <div className="col fs-14px fw-500">
                                                          {totals.reimbursement_order_value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                        </div>
                                                      </div>
                                                    );
                                                  })()}
                                                  
                                                </div>
                                              }
                                            </div>
                                          </Accordion.Body>
                                        </Accordion.Item>
                                      </Accordion>

                                      <Accordion
                                        activeKey={activeKeys}
                                        style={{ border: "0" }}
                                      >
                                        <Accordion.Item
                                          eventKey="103"
                                          style={{ borderRadius: "0", border: "0" }}
                                        >
                                          <Accordion.Header
                                            onClick={() => toggleAccordion("103")}
                                          >
                                            <div className="w-100 d-flex justify-content-between">
                                              <span>Salary</span>
                                              <span
                                                className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                style={{
                                                  height: "13.33px",
                                                  width: "13.33px",
                                                }}
                                              >
                                                {activeKeys.includes("103")
                                                  ? "-"
                                                  : "+"}
                                              </span>
                                            </div>
                                          </Accordion.Header>

                                          <Accordion.Body>
                                            <div>
                                              {
                                                <div className="row my-1 mx-0">
                                                  <div className="row m-0 px-0">
                                                    <div className="col-2 fs-12px text-black-60">
                                                      Sanction Order Date
                                                    </div>
                                                    <div className="col-2 fs-12px text-black-60">
                                                      Sanction Order No.
                                                    </div>
                                                    <div className="col-2 fs-12px text-black-60">
                                                      Financial Year
                                                    </div>
                                                    <div className="col-2 fs-12px text-black-60">
                                                      Salary Type
                                                    </div>
                                                    <div className="col-2 fs-12px text-black-60">
                                                      Employees Count
                                                    </div>
                                                    <div className="col-2 fs-12px text-black-60">
                                                      Gross Amount / Invoice Value
                                                    </div>
                                                  </div>
                                                  {
                                                    schemeSalaryList?.filter(salary => salary.subhead_id === subhead.id)?.map((salary, index) => (
                                                      <div className="row mt-1 m-0 px-0" key={index}>
                                                        <div className="col-2 fs-14px fw-500">
                                                          {salary.sanction_order_date}
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500">
                                                          {salary.sanction_order_no}
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500">
                                                          {getYears(salary.financial_year_id)}
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500">
                                                          {salary.salary_type}
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500">
                                                          {salary.employee_count}
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500">
                                                          {(Number(salary.invoice_value) > 0) ? salary.invoice_value : salary.gross_amount}
                                                        </div>
                                                      </div>
                                                    ))
                                                  }
                                                  
                                                  
                                                  {/* =================== total row value ============== */}
                                                  {(() => {
                                                    const filteredBudgets = schemeSalaryList?.filter(b => b.subhead_id === subhead.id);

                                                    const totals = filteredBudgets.reduce(
                                                      (acc, curr) => {
                                                        let amt = (Number(curr.invoice_value) > 0) ? Number(curr.invoice_value) : Number(curr.gross_amount);
                                                        acc.gross_amount += Number(amt || 0);
                                                        return acc;
                                                      },
                                                      { gross_amount: 0}
                                                    );

                                                    return (
                                                      <div className="row bg-info-20 py-1 px-0 m-0">
                                                        <div className="col fs-14px fw-500 text-prime-100">
                                                          Total
                                                        </div>
                                                        <div className="col fs-14px fw-500 m-0">
                                                         
                                                        </div>
                                                        <div className="col fs-14px fw-500">
                                                          
                                                        </div>
                                                        <div className="col fs-14px fw-500">
                                                          
                                                        </div>
                                                        <div className="col fs-14px fw-500">
                                                          
                                                        </div>
                                                        <div className="col fs-14px fw-500">
                                                          {totals.gross_amount.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                        </div>
                                                      </div>
                                                    );
                                                  })()}
                                                </div>
                                              }
                                            </div>
                                          </Accordion.Body>
                                        </Accordion.Item>
                                      </Accordion>

                                      <Accordion
                                        activeKey={activeKeys}
                                        style={{ border: "0" }}
                                      >
                                        <Accordion.Item
                                          eventKey={`surredner_done_${subhead.id}`}
                                          style={{ borderRadius: "0", border: "0" }}
                                        >
                                          <Accordion.Header
                                            onClick={() => toggleAccordion(`surredner_done_${subhead.id}`)}
                                          >
                                            <div className="w-100 d-flex justify-content-between">
                                              <span>Budget Surrender</span>
                                              <span
                                                className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                style={{
                                                  height: "13.33px",
                                                  width: "13.33px",
                                                }}
                                              >
                                                {activeKeys.includes("100")
                                                  ? "-"
                                                  : "+"}
                                              </span>
                                            </div>
                                          </Accordion.Header>

                                          <Accordion.Body>
                                            <div>
                                              
                                                <div className="row my-1 mx-0">
                                                  <div className="row m-0 px-0">
                                                    <div className="col-2 fs-12px text-black-60">
                                                      Sr.
                                                    </div>
                                                    <div className="col-3 fs-12px text-black-60">
                                                      Order No.
                                                    </div>
                                                    <div className="col-2 fs-12px text-black-60">
                                                      Order Date
                                                    </div>
                                                    <div className="col-3 fs-12px text-black-60">
                                                      Surrender Done By
                                                    </div>
                                                    <div className="col-2 fs-12px text-black-60">
                                                      Amount
                                                    </div>
                                                  </div>

                                                  {
                                                    surrenderDoneList.filter(e => e.subhead_id == subhead.id).map((surrender, sIndex) => (
                                                      <div className="row mt-1 m-0 px-0" key={sIndex}>
                                                        <div className="col-2 fs-14px fw-500">
                                                          {sIndex + 1}
                                                        </div>
                                                        <div className="col-3 fs-14px fw-500">
                                                          {surrender.order_no}
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500">
                                                          {surrender.order_date}
                                                        </div>
                                                        <div className="col-3 fs-14px fw-500">
                                                          {surrender.name}
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500">
                                                          {surrender.amount}
                                                        </div>
                                                      </div>
                                                    ))
                                                  }

                                                  {/* =================== total row value ============== */}
                                                  {(() => {
                                                    const filteredBudgets = surrenderDoneList.filter(b => b.subhead_id === subhead.id);

                                                    const totals = filteredBudgets.reduce(
                                                      (acc, curr) => {
                                                        acc.amount += Number(curr.amount || 0);
                                                        return acc;
                                                      },
                                                      { amount: 0 }
                                                    );

                                                    return (
                                                      <div className="row bg-info-20 py-1 px-0 m-0">
                                                        <div className="col-2 fs-14px fw-500 text-prime-100">
                                                          Total
                                                        </div>
                                                        <div className="col-3 fs-14px fw-500">
                                                          
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500">
                                                          
                                                        </div>
                                                        <div className="col-3 fs-14px fw-500">
                                                          
                                                        </div>
                                                        <div className="col-2 fs-14px fw-500 text-success-100">
                                                            {totals.amount.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                        </div>
                                                      </div>
                                                    );
                                                  })()}
                                                  
                                                </div>
                                              
                                            </div>
                                          </Accordion.Body>
                                        </Accordion.Item>
                                      </Accordion>

                                      {
                                        authData.user.department_details.is_multi === "1" && 
                                        <Accordion
                                        activeKey={activeKeys}
                                        style={{ border: "0" }}
                                        >
                                          <Accordion.Item
                                            eventKey={`subhead_budget_allocation_${subhead.id}`}
                                            style={{ borderRadius: "0", border: "0" }}
                                          >
                                            <Accordion.Header
                                              onClick={() => toggleAccordion(`subhead_budget_allocation_${subhead.id}`)}
                                            >
                                              <div className="w-100 d-flex justify-content-between">
                                                <span>Budget Allocation</span>
                                                <span
                                                  className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                  style={{
                                                    height: "13.33px",
                                                    width: "13.33px",
                                                  }}
                                                >
                                                  {activeKeys.includes(`subhead_budget_allocation_${subhead.id}`)
                                                    ? "-"
                                                    : "+"}
                                                </span>
                                              </div>
                                            </Accordion.Header>

                                            <Accordion.Body>
                                              <div>
                                                {
                                                  <div className="row my-1 mx-0">
                                                    <div className="row m-0 px-0">
                                                      <div className="col-2 fs-12px text-black-60">
                                                        Sr.
                                                      </div>
                                                      <div className="col-2 fs-12px text-black-60">
                                                        Total Dept.
                                                      </div>
                                                      <div className="col-2 fs-12px text-black-60">
                                                        Order No.
                                                      </div>
                                                      <div className="col-2 fs-12px text-black-60">
                                                        Order Date
                                                      </div>
                                                      <div className="col-2 fs-12px text-black-60">
                                                        Provision Budget
                                                      </div>
                                                      <div className="col-2 fs-12px text-black-60">
                                                        Released Budget
                                                      </div>
                                                    </div>

                                                    {
                                                      schemeAllocationList?.filter(allocation => allocation.subhead_id === subhead.id).map((allocation, idx) => (
                                                        <div className="row mt-1 m-0 px-0" key={idx}>
                                                          <div className="col-2 fs-14px fw-500">
                                                            {idx + 1}
                                                          </div>
                                                          <div className="col-2 fs-14px fw-500">
                                                            {allocation?.department_count}
                                                          </div>
                                                          <div className="col-2 fs-14px fw-500">
                                                            {allocation?.budget_order_no}
                                                          </div>
                                                          <div className="col-2 fs-14px fw-500">
                                                            {allocation?.budget_order_date}
                                                          </div>
                                                          <div className="col-2 fs-14px fw-500">
                                                            {allocation?.subhead_provisional_budget.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                          </div>
                                                          <div className="col-2 fs-14px fw-500">
                                                            {allocation?.subhead_budget.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                          </div>
                                                        </div>
                                                      ))
                                                    }

                                                    {/* =================== total row value ============== */}
                                                    {(() => {
                                                      const filteredBudgets = schemeAllocationList?.filter(b => b.subhead_id === subhead.id);

                                                      const totals = filteredBudgets.reduce(
                                                        (acc, curr) => {
                                                          acc.subhead_provisional_budget += Number(curr.subhead_provisional_budget || 0);
                                                          acc.subhead_budget += Number(curr.subhead_budget || 0);
                                                          return acc;
                                                        },
                                                        { subhead_provisional_budget: 0, subhead_budget: 0 }
                                                      );

                                                      return (
                                                        <div className="row bg-info-20 py-1 px-0 m-0">
                                                          <div className="col-2 fs-14px fw-500 text-prime-100">
                                                            Total
                                                          </div>
                                                          <div className="col-2 fs-14px fw-500 m-0">
                                                            
                                                          </div>
                                                          <div className="col-2 fs-14px fw-500">
                                                            
                                                          </div>
                                                          <div className="col-2 fs-14px fw-500">
                                                            
                                                          </div>
                                                          <div className="col-2 fs-14px fw-500">
                                                            {totals.subhead_provisional_budget.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                          </div>
                                                          <div className="col-2 fs-14px fw-500 text-success-100">
                                                            {totals.subhead_budget.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                          </div>
                                                        </div>
                                                      );
                                                    })()}
                                                    
                                                  </div>
                                                }
                                              </div>
                                            </Accordion.Body>
                                          </Accordion.Item>
                                        </Accordion>
                                      }
                                      
                                    </div>
                                    <div className="py-1 px-2 mx-0 bg-prime-100">
                                      <div className="fs-14px text-white m-0 d-flex justify-content-end align-items-center gap-2 py-2">
                                        <span className="fs-12px">Receipt</span>{" "}
                                        {(Number(schemeDetails.total_budget) + Number(schemeDetails.prevYearBalance)).toLocaleString("en-IN", { minimumFractionDigits: 2 })} <span>-</span>{" "}
                                        <span className="fs-12px">Payment</span>{" "}
                                        {Number(schemeDetails.utilised_budget).toLocaleString("en-IN", { minimumFractionDigits: 2 })} <span>=</span>{" "}
                                        <span className="fs-12px">Total</span>{" "}
                                        {((Number(schemeDetails.total_budget) + Number(schemeDetails.prevYearBalance)) - Number(schemeDetails.utilised_budget)).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          ))
                        }
                        
                      </div>
                    </div>
                  )}
                  {/* ========================================activity=========================== */}
                  {activeCard.includes(`activity_${schemeDetails.id}`) && (
                    <div>
                      {schemeDetails.sub_head_list?.map((subhead, index) => (
                      <Accordion activeKey={activeKeys} style={{ border: "0" }}>
                        <Accordion.Item
                          eventKey={`activity_${subhead.id}`}
                          style={{ borderRadius: "0", border: "0" }}
                        >
                          <Accordion.Header
                            onClick={() => toggleAccordion(`activity_${subhead.id}`)}
                          >
                            <div className="w-100 d-flex justify-content-between">
                              <span>{subhead.name}</span>
                              <span
                                className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                style={{
                                  height: "13.33px",
                                  width: "13.33px",
                                }}
                              >
                                {activeKeys.includes(`activity_${subhead.id}`) ? "-" : "+"}
                              </span>
                            </div>
                          </Accordion.Header>

                          <Accordion.Body>
                            <div>
                              {
                                shortActivitiesFromSubhead(subhead?.activity_budget)?.map((activity, activityindex) => (
                                  <div className="subhead" key={activityindex}>
                                    <div className="row">
                                      <div className="row pt-2 m-0">
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                          <span className="text-black-60 fs-12px">
                                            Activity
                                          </span>
                                        </div>
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                          <span className="text-black-60 fs-12px">
                                            FY{" "}
                                            {fy_list?.map((val, ind) => {
                                              return (
                                                val?.id == globalDateId &&
                                                val?.year
                                              );
                                            })}
                                          </span>
                                        </div>
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                          <span className="text-black-60 fs-12px">
                                            Previous FY Balance
                                          </span>
                                          <i className="icon-info"></i>
                                        </div>
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                          <span className="text-black-60 fs-12px">
                                            Total
                                          </span>
                                        </div>
                                      </div>
                                      {/* ===================================values================================= */}
                                      <div className="row pb-2 m-0">
                                        <div className="col-3 d-flex align-items-center">
                                          {/* {ledSubHeadAccordion ? (
                                            <i
                                              className="icon-keyboard_arrow_right cursor-pointer"
                                              onClick={() =>
                                                subheadAccordianSwitch(`activity_${activity.activityId}`)
                                              }
                                            ></i>
                                          ) : (
                                            <i
                                              className="icon-keyboard_arrow_down cursor-pointer"
                                              onClick={() =>
                                                subheadAccordianSwitch(`activity_${activity.activityId}`)
                                              }
                                            ></i>
                                          )} */}
                                          <span className="fs-14px fw-500">
                                            {activity?.activityName}
                                          </span>
                                        </div>
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                          <span className="fs-14px fw-500">
                                            {activity.budgetGet}
                                          </span>
                                        </div>
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                          <span className="fs-14px fw-500">
                                            {activity.prev_balance}
                                          </span>
                                        </div>
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                          <span className="fs-14px fw-500 text-success-100">
                                            {activity.budgetGet + activity.prev_balance}
                                          </span>
                                        </div>

                                        {/* ==============================sub data========================== */}

                                        {!ledSubHeadAccordion && (
                                          <>
                                            <div>
                                              <h3 className="fw-600 fs-18px my-2">
                                                Receipt (Inflow)
                                              </h3>

                                              <div className=" pb-2 d-flex flex-column gap-1 mt-2">
                                                <Accordion
                                                  activeKey={activeKeys}
                                                  style={{ border: "0" }}
                                                >
                                                  <Accordion.Item
                                                    eventKey="10"
                                                    style={{
                                                      borderRadius: "0",
                                                      border: "0",
                                                    }}
                                                  >
                                                    <Accordion.Header
                                                      onClick={() =>
                                                        toggleAccordion("10")
                                                      }
                                                      // style={{
                                                      //   display: "flex",
                                                      //   justifyContent: "space-between",
                                                      //   alignItems: "center",
                                                      //   position: "relative",
                                                      //   borderRadius: "0",
                                                      //   padding:"0"
                                                      // }}
                                                    >
                                                      <div className="w-100 d-flex justify-content-between">
                                                        <span>Budget</span>
                                                        <span
                                                          className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                          style={{
                                                            height: "13.33px",
                                                            width: "13.33px",
                                                          }}
                                                        >
                                                          {activeKeys.includes(
                                                            "10"
                                                          )
                                                            ? "-"
                                                            : "+"}
                                                        </span>
                                                      </div>
                                                    </Accordion.Header>

                                                    <Accordion.Body>
                                                      <div>
                                                        {
                                                          <div className="row my-1 p-0 mx-0">
                                                            <div className="row m-0 px-0">
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Sr.
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Sub Head
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Order No.
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Order Date
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Provision Budget
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Released Budget
                                                              </div>
                                                            </div>
                                                            <div className="row mt-1 m-0 px-0">
                                                              <div className="col-2 fs-14px fw-500">
                                                                sr. here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                subHead here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 text-success-100">
                                                                2,000,000,000.00
                                                              </div>
                                                            </div>
                                                            <div className="row mt-1 m-0 px-0">
                                                              <div className="col-2 fs-14px fw-500">
                                                                Title here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                sr. here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 text-success-100">
                                                                2,000,000,000.00
                                                              </div>
                                                            </div>
                                                            {/* =================== total row value ============== */}
                                                            <div className="row bg-info-20 py-1 px-0 m-0">
                                                              <div className="col-2 fs-14px fw-500 text-prime-100">
                                                                Total
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 m-0">
                                                                bla bla bla
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 text-success-100">
                                                                2,000,000,000.00
                                                              </div>
                                                            </div>
                                                          </div>
                                                        }
                                                      </div>
                                                    </Accordion.Body>
                                                  </Accordion.Item>
                                                </Accordion>

                                                <Accordion
                                                  activeKey={activeKeys}
                                                  style={{ border: "0" }}
                                                >
                                                  <Accordion.Item
                                                    eventKey="11"
                                                    style={{
                                                      borderRadius: "0",
                                                      border: "0",
                                                    }}
                                                  >
                                                    <Accordion.Header
                                                      onClick={() =>
                                                        toggleAccordion("11")
                                                      }
                                                      // style={{
                                                      //   display: "flex",
                                                      //   justifyContent: "space-between",
                                                      //   alignItems: "center",
                                                      //   position: "relative",
                                                      //   borderRadius: "0",
                                                      //   padding:"0"
                                                      // }}
                                                    >
                                                      <div className="w-100 d-flex justify-content-between">
                                                        <span>
                                                          Budget Allocation
                                                        </span>
                                                        <span
                                                          className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                          style={{
                                                            height: "13.33px",
                                                            width: "13.33px",
                                                          }}
                                                        >
                                                          {activeKeys.includes(
                                                            "11"
                                                          )
                                                            ? "-"
                                                            : "+"}
                                                        </span>
                                                      </div>
                                                    </Accordion.Header>

                                                    <Accordion.Body>
                                                      <div>
                                                        {
                                                          <div className="row my-1 mx-0">
                                                            <div className="row m-0 px-0">
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Sr.
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Total Dept.
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Order No.
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Order Date
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Provision Budget
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Released Budget
                                                              </div>
                                                            </div>
                                                            <div className="row mt-1 m-0 px-0">
                                                              <div className="col-2 fs-14px fw-500">
                                                                Title here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                sr. here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 text-success-100">
                                                                2,000,000,000.00
                                                              </div>
                                                            </div>
                                                            <div className="row mt-1 m-0 px-0">
                                                              <div className="col-2 fs-14px fw-500">
                                                                Title here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                sr. here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 text-success-100">
                                                                2,000,000,000.00
                                                              </div>
                                                            </div>
                                                            {/* =================== total row value ============== */}
                                                            <div className="row bg-info-20 py-1 px-0 m-0">
                                                              <div className="col-2 fs-14px fw-500 text-prime-100">
                                                                Total
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 m-0">
                                                                bla bla bla
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 text-success-100">
                                                                2,000,000,000.00
                                                              </div>
                                                            </div>
                                                          </div>
                                                        }
                                                      </div>
                                                    </Accordion.Body>
                                                  </Accordion.Item>
                                                </Accordion>

                                                <Accordion
                                                  activeKey={activeKeys}
                                                  style={{ border: "0" }}
                                                >
                                                  <Accordion.Item
                                                    eventKey="100"
                                                    style={{
                                                      borderRadius: "0",
                                                      border: "0",
                                                    }}
                                                  >
                                                    <Accordion.Header
                                                      onClick={() =>
                                                        toggleAccordion("100")
                                                      }
                                                    >
                                                      <div className="w-100 d-flex justify-content-between">
                                                        <span>
                                                          Budget Repropregation
                                                        </span>
                                                        <span
                                                          className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                          style={{
                                                            height: "13.33px",
                                                            width: "13.33px",
                                                          }}
                                                        >
                                                          {activeKeys.includes(
                                                            "100"
                                                          )
                                                            ? "-"
                                                            : "+"}
                                                        </span>
                                                      </div>
                                                    </Accordion.Header>

                                                    <Accordion.Body>
                                                      <div>
                                                        {
                                                          <div className="row my-1 mx-0">
                                                            <div className="row m-0 px-0">
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Title
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Sr.
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Order No.
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Order Date
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Provision Budget
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Released Budget
                                                              </div>
                                                            </div>
                                                            <div className="row mt-1 m-0 px-0">
                                                              <div className="col-2 fs-14px fw-500">
                                                                Title here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                sr. here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 text-success-100">
                                                                2,000,000,000.00
                                                              </div>
                                                            </div>
                                                            <div className="row mt-1 m-0 px-0">
                                                              <div className="col-2 fs-14px fw-500">
                                                                Title here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                sr. here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 text-success-100">
                                                                2,000,000,000.00
                                                              </div>
                                                            </div>
                                                            {/* =================== total row value ============== */}
                                                            <div className="row bg-info-20 py-1 px-0 m-0">
                                                              <div className="col-2 fs-14px fw-500 text-prime-100">
                                                                Total
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 m-0">
                                                                bla bla bla
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 text-success-100">
                                                                2,000,000,000.00
                                                              </div>
                                                            </div>
                                                          </div>
                                                        }
                                                      </div>
                                                    </Accordion.Body>
                                                  </Accordion.Item>
                                                </Accordion>

                                                <div className="row bg-info-20 py-1 px-0 m-0">
                                                  <div className="col-2 fs-14px fw-500 text-prime-100">
                                                    Total
                                                  </div>
                                                  <div className="col-2 fs-14px fw-500 m-0">
                                                    bla bla bla
                                                  </div>
                                                  <div className="col-2 fs-14px fw-500">
                                                    2,000,000,000.00
                                                  </div>
                                                  <div className="col-2 fs-14px fw-500">
                                                    2,000,000,000.00
                                                  </div>
                                                  <div className="col-2 fs-14px fw-500">
                                                    2,000,000,000.00
                                                  </div>
                                                  <div className="col-2 fs-14px fw-500 text-success-100">
                                                    2,000,000,000.00
                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                            <div>
                                              <h3 className="fw-600 fs-18px my-2">
                                                Payment (Outflow)
                                              </h3>

                                              <div className=" py-1 d-flex flex-column gap-1 mt-2">
                                                <Accordion
                                                  activeKey={activeKeys}
                                                  style={{ border: "0" }}
                                                >
                                                  <Accordion.Item
                                                    eventKey="101"
                                                    style={{
                                                      borderRadius: "0",
                                                      border: "0",
                                                    }}
                                                  >
                                                    <Accordion.Header
                                                      onClick={() =>
                                                        toggleAccordion("101")
                                                      }
                                                    >
                                                      <div className="w-100 d-flex justify-content-between">
                                                        <span>Vendor</span>
                                                        <span
                                                          className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                          style={{
                                                            height: "13.33px",
                                                            width: "13.33px",
                                                          }}
                                                        >
                                                          {activeKeys.includes(
                                                            "101"
                                                          )
                                                            ? "-"
                                                            : "+"}
                                                        </span>
                                                      </div>
                                                    </Accordion.Header>

                                                    <Accordion.Body>
                                                      <div>
                                                        {
                                                          <div className="row my-1 mx-0">
                                                            <div className="row m-0 px-0">
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Sr.
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Vendor
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Invoice / Date
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Sanctioned Order /
                                                                Date
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Invoice Amount
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Sanctioned Amount
                                                              </div>
                                                            </div>
                                                            <div className="row mt-1 m-0 px-0">
                                                              <div className="col-2 fs-14px fw-500">
                                                                Title here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                sr. here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                            </div>
                                                            <div className="row mt-1 m-0 px-0">
                                                              <div className="col-2 fs-14px fw-500">
                                                                Title here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                sr. here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 text-success-100">
                                                                2,000,000,000.00
                                                              </div>
                                                            </div>
                                                            {/* =================== total row value ============== */}
                                                            <div className="row bg-info-20 py-1 px-0 m-0">
                                                              <div className="col-2 fs-14px fw-500 text-prime-100">
                                                                Total
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 m-0">
                                                                bla bla bla
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 text-success-100">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 text-success-100">
                                                                2,000,000,000.00
                                                              </div>
                                                            </div>
                                                          </div>
                                                        }
                                                      </div>
                                                    </Accordion.Body>
                                                  </Accordion.Item>
                                                </Accordion>

                                                <Accordion
                                                  activeKey={activeKeys}
                                                  style={{ border: "0" }}
                                                >
                                                  <Accordion.Item
                                                    eventKey="102"
                                                    style={{
                                                      borderRadius: "0",
                                                      border: "0",
                                                    }}
                                                  >
                                                    <Accordion.Header
                                                      onClick={() =>
                                                        toggleAccordion("102")
                                                      }
                                                      // style={{
                                                      //   display: "flex",
                                                      //   justifyContent: "space-between",
                                                      //   alignItems: "center",
                                                      //   position: "relative",
                                                      //   borderRadius: "0",
                                                      //   padding:"0"
                                                      // }}
                                                    >
                                                      <div className="w-100 d-flex justify-content-between">
                                                        <span>DBT/NACH</span>
                                                        <span
                                                          className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                          style={{
                                                            height: "13.33px",
                                                            width: "13.33px",
                                                          }}
                                                        >
                                                          {activeKeys.includes(
                                                            "102"
                                                          )
                                                            ? "-"
                                                            : "+"}
                                                        </span>
                                                      </div>
                                                    </Accordion.Header>

                                                    <Accordion.Body>
                                                      <div>
                                                        {
                                                          <div className="row my-1 mx-0">
                                                            <div className="row m-0 px-0">
                                                              <div className="col fs-12px text-black-60">
                                                                Sr.
                                                              </div>
                                                              <div className="col fs-12px text-black-60">
                                                                Department
                                                                Level/Name
                                                              </div>
                                                              <div className="col fs-12px text-black-60">
                                                                Scheme/Subhead
                                                                Code
                                                              </div>
                                                              <div className="col fs-12px text-black-60">
                                                                Order / Date
                                                              </div>
                                                              <div className="col fs-12px text-black-60">
                                                                Sanction Amount
                                                              </div>
                                                              <div className="col fs-12px text-black-60">
                                                                Deduction Amount
                                                              </div>
                                                              <div className="col fs-12px text-black-60">
                                                                Payment Amount
                                                              </div>
                                                            </div>

                                                            <div className="row mt-1 m-0 px-0">
                                                              <div className="col fs-14px fw-500">
                                                                Title here
                                                              </div>
                                                              <div className="col fs-14px fw-500">
                                                                sr. here
                                                              </div>
                                                              <div className="col fs-14px fw-500">
                                                                2,000
                                                              </div>
                                                              <div className="col fs-14px fw-500">
                                                                2,000
                                                              </div>
                                                              <div className="col fs-14px fw-500">
                                                                2,000
                                                              </div>
                                                              <div className="col fs-14px fw-500">
                                                                2,000
                                                              </div>
                                                              <div className="col fs-14px fw-500 text-success-100">
                                                                2,000
                                                              </div>
                                                            </div>
                                                            {/* =================== total row value ============== */}
                                                            <div className="row bg-info-20 py-1 px-0 m-0">
                                                              <div className="col fs-14px fw-500 text-prime-100">
                                                                Total
                                                              </div>
                                                              <div className="col fs-14px fw-500 m-0">
                                                                bla bla bla
                                                              </div>
                                                              <div className="col fs-14px fw-500">
                                                                2,000
                                                              </div>
                                                              <div className="col fs-14px fw-500">
                                                                2,000
                                                              </div>
                                                              <div className="col fs-14px fw-500">
                                                                2,000
                                                              </div>
                                                              <div className="col fs-14px fw-500">
                                                                2,000
                                                              </div>
                                                              <div className="col fs-14px fw-500">
                                                                2,000
                                                              </div>
                                                            </div>
                                                          </div>
                                                        }
                                                      </div>
                                                    </Accordion.Body>
                                                  </Accordion.Item>
                                                </Accordion>

                                                <Accordion
                                                  activeKey={activeKeys}
                                                  style={{ border: "0" }}
                                                >
                                                  <Accordion.Item
                                                    eventKey="103"
                                                    style={{
                                                      borderRadius: "0",
                                                      border: "0",
                                                    }}
                                                  >
                                                    <Accordion.Header
                                                      onClick={() =>
                                                        toggleAccordion("103")
                                                      }
                                                    >
                                                      <div className="w-100 d-flex justify-content-between">
                                                        <span>Salary</span>
                                                        <span
                                                          className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                          style={{
                                                            height: "13.33px",
                                                            width: "13.33px",
                                                          }}
                                                        >
                                                          {activeKeys.includes(
                                                            "103"
                                                          )
                                                            ? "-"
                                                            : "+"}
                                                        </span>
                                                      </div>
                                                    </Accordion.Header>

                                                    <Accordion.Body>
                                                      <div>
                                                        {
                                                          <div className="row my-1 mx-0">
                                                            <div className="row m-0 px-0">
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Title
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Sr.
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Order No.
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Order Date
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Provision Budget
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Released Budget
                                                              </div>
                                                            </div>
                                                            <div className="row mt-1 m-0 px-0">
                                                              <div className="col-2 fs-14px fw-500">
                                                                Title here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                sr. here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 text-success-100">
                                                                2,000,000,000.00
                                                              </div>
                                                            </div>
                                                            <div className="row mt-1 m-0 px-0">
                                                              <div className="col-2 fs-14px fw-500">
                                                                Title here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                sr. here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 text-success-100">
                                                                2,000,000,000.00
                                                              </div>
                                                            </div>
                                                            {/* =================== total row value ============== */}
                                                            <div className="row bg-info-20 py-1 px-0 m-0">
                                                              <div className="col-2 fs-14px fw-500 text-prime-100">
                                                                Total
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 m-0">
                                                                bla bla bla
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 text-success-100">
                                                                2,000,000,000.00
                                                              </div>
                                                            </div>
                                                          </div>
                                                        }
                                                      </div>
                                                    </Accordion.Body>
                                                  </Accordion.Item>
                                                </Accordion>

                                                <Accordion
                                                  activeKey={activeKeys}
                                                  style={{ border: "0" }}
                                                >
                                                  <Accordion.Item
                                                    eventKey="105"
                                                    style={{
                                                      borderRadius: "0",
                                                      border: "0",
                                                    }}
                                                  >
                                                    <Accordion.Header
                                                      onClick={() =>
                                                        toggleAccordion("105")
                                                      }
                                                    >
                                                      <div className="w-100 d-flex justify-content-between">
                                                        <span>
                                                          Budget Allocation
                                                        </span>
                                                        <span
                                                          className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                          style={{
                                                            height: "13.33px",
                                                            width: "13.33px",
                                                          }}
                                                        >
                                                          {activeKeys.includes(
                                                            "105"
                                                          )
                                                            ? "-"
                                                            : "+"}
                                                        </span>
                                                      </div>
                                                    </Accordion.Header>

                                                    <Accordion.Body>
                                                      <div>
                                                        {
                                                          <div className="row my-1 mx-0">
                                                            <div className="row m-0 px-0">
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Sr.
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Total Dept.
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Order No.
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Order Date
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Provision Budget
                                                              </div>
                                                              <div className="col-2 fs-12px text-black-60">
                                                                Released Budget
                                                              </div>
                                                            </div>
                                                            <div className="row mt-1 m-0 px-0">
                                                              <div className="col-2 fs-14px fw-500">
                                                                Title here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                sr. here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 text-success-100">
                                                                2,000,000,000.00
                                                              </div>
                                                            </div>
                                                            <div className="row mt-1 m-0 px-0">
                                                              <div className="col-2 fs-14px fw-500">
                                                                Title here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                sr. here
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 text-success-100">
                                                                2,000,000,000.00
                                                              </div>
                                                            </div>
                                                            {/* =================== total row value ============== */}
                                                            <div className="row bg-info-20 py-1 px-0 m-0">
                                                              <div className="col-2 fs-14px fw-500 text-prime-100">
                                                                Total
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 m-0">
                                                                bla bla bla
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500">
                                                                2,000,000,000.00
                                                              </div>
                                                              <div className="col-2 fs-14px fw-500 text-success-100">
                                                                2,000,000,000.00
                                                              </div>
                                                            </div>
                                                          </div>
                                                        }
                                                      </div>
                                                    </Accordion.Body>
                                                  </Accordion.Item>
                                                </Accordion>

                                                <div className="row bg-info-20 py-1 px-0 m-0">
                                                  <div className="col-2 fs-14px fw-500 text-prime-100">
                                                    Total
                                                  </div>
                                                  <div className="col-2 fs-14px fw-500 m-0">
                                                    bla bla bla
                                                  </div>
                                                  <div className="col-2 fs-14px fw-500">
                                                    2,000,000,000.00
                                                  </div>
                                                  <div className="col-2 fs-14px fw-500">
                                                    2,000,000,000.00
                                                  </div>
                                                  <div className="col-2 fs-14px fw-500">
                                                    2,000,000,000.00
                                                  </div>
                                                  <div className="col-2 fs-14px fw-500 text-success-100">
                                                    2,000,000,000.00
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="py-1 px-2 mx-0 bg-prime-100">
                                                <div className="fs-14px text-white m-0 d-flex justify-content-end align-items-center gap-2 py-2">
                                                  <span className="fs-12px">
                                                    Receipt
                                                  </span>{" "}
                                                  50,00,000 <span>-</span>{" "}
                                                  <span className="fs-12px">
                                                    Payment
                                                  </span>{" "}
                                                  25,00,000 <span>=</span>{" "}
                                                  <span className="fs-12px">
                                                    Total
                                                  </span>{" "}
                                                  25,00,000
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ))
                              }
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                      ))}
                    </div>
                  )}

                  {activeCard.includes(`subactivity_${schemeDetails.id}`) && (
                    <div>
                      <Accordion activeKey={activeKeys} style={{ border: "0" }}>
                        <Accordion.Item
                          eventKey="21"
                          style={{ borderRadius: "0", border: "0" }}
                        >
                          <Accordion.Header
                            onClick={() => toggleAccordion("21")}
                            // style={{
                            //   display: "flex",
                            //   justifyContent: "space-between",
                            //   alignItems: "center",
                            //   position: "relative",
                            //   borderRadius: "0",
                            //   padding:"0"
                            // }}
                          >
                            <div className="w-100 d-flex justify-content-between">
                              <span>Subhead Name | Activity</span>
                              <span
                                className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                style={{
                                  height: "13.33px",
                                  width: "13.33px",
                                }}
                              >
                                {activeKeys.includes("21") ? "-" : "+"}
                              </span>
                            </div>
                          </Accordion.Header>

                          <Accordion.Body>
                            <div>
                              {
                                <div className="subhead">
                                  <div className="row">
                                    <div className="row pt-2 m-0">
                                      <div className="col-3 d-flex justify-content-between align-items-center">
                                        <span className="text-black-60 fs-12px">
                                          Sub-Activity
                                        </span>
                                      </div>
                                      <div className="col-3 d-flex justify-content-between align-items-center">
                                        <span className="text-black-60 fs-12px">
                                          FY{" "}
                                          {fy_list?.map((val, ind) => {
                                            return (
                                              val?.id == globalDateId &&
                                              val?.year
                                            );
                                          })}
                                        </span>
                                      </div>
                                      <div className="col-3 d-flex justify-content-between align-items-center">
                                        <span className="text-black-60 fs-12px">
                                          Previous FY Balance
                                        </span>
                                        <i className="icon-info"></i>
                                      </div>
                                      <div className="col-3 d-flex justify-content-between align-items-center">
                                        <span className="text-black-60 fs-12px">
                                          Total
                                        </span>
                                      </div>
                                    </div>
                                    {/* ===================================values================================= */}
                                    <div className="row pb-2 m-0">
                                      <div className="col-3 d-flex align-items-center">
                                        {ledSubHeadAccordion ? (
                                          <i
                                            className="icon-keyboard_arrow_right cursor-pointer"
                                            onClick={() =>
                                              setledSubHeadAccordion(false)
                                            }
                                          ></i>
                                        ) : (
                                          <i
                                            className="icon-keyboard_arrow_down cursor-pointer"
                                            onClick={() =>
                                              setledSubHeadAccordion(true)
                                            }
                                          ></i>
                                        )}
                                        <span className="fs-14px fw-500">
                                          Activity
                                        </span>
                                      </div>
                                      <div className="col-3 d-flex justify-content-between align-items-center">
                                        <span className="fs-14px fw-500">
                                          2,000,000,000.00
                                        </span>
                                      </div>
                                      <div className="col-3 d-flex justify-content-between align-items-center">
                                        <span className="fs-14px fw-500">
                                          2,000,000,000.00
                                        </span>
                                      </div>
                                      <div className="col-3 d-flex justify-content-between align-items-center">
                                        <span className="fs-14px fw-500 text-success-100">
                                          2,000,000,000.00
                                        </span>
                                      </div>

                                      {/* ==============================sub data========================== */}

                                      {!ledSubHeadAccordion && (
                                        <>
                                          <div>
                                            <h3 className="fw-600 fs-18px my-2">
                                              Receipt (Inflow)
                                            </h3>

                                            <div className=" pb-2 d-flex flex-column gap-1 mt-2">
                                              <Accordion
                                                activeKey={activeKeys}
                                                style={{ border: "0" }}
                                              >
                                                <Accordion.Item
                                                  eventKey="10"
                                                  style={{
                                                    borderRadius: "0",
                                                    border: "0",
                                                  }}
                                                >
                                                  <Accordion.Header
                                                    onClick={() =>
                                                      toggleAccordion("10")
                                                    }
                                                    // style={{
                                                    //   display: "flex",
                                                    //   justifyContent: "space-between",
                                                    //   alignItems: "center",
                                                    //   position: "relative",
                                                    //   borderRadius: "0",
                                                    //   padding:"0"
                                                    // }}
                                                  >
                                                    <div className="w-100 d-flex justify-content-between">
                                                      <span>Budget</span>
                                                      <span
                                                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                        style={{
                                                          height: "13.33px",
                                                          width: "13.33px",
                                                        }}
                                                      >
                                                        {activeKeys.includes(
                                                          "10"
                                                        )
                                                          ? "-"
                                                          : "+"}
                                                      </span>
                                                    </div>
                                                  </Accordion.Header>

                                                  <Accordion.Body>
                                                    <div>
                                                      {
                                                        <div className="row my-1 p-0 mx-0">
                                                          <div className="row m-0 px-0">
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Sr.
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Sub Head
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Order No.
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Order Date
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Provision Budget
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Released Budget
                                                            </div>
                                                          </div>
                                                          <div className="row mt-1 m-0 px-0">
                                                            <div className="col-2 fs-14px fw-500">
                                                              sr. here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              subHead here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 text-success-100">
                                                              2,000,000,000.00
                                                            </div>
                                                          </div>
                                                          <div className="row mt-1 m-0 px-0">
                                                            <div className="col-2 fs-14px fw-500">
                                                              Title here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              sr. here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 text-success-100">
                                                              2,000,000,000.00
                                                            </div>
                                                          </div>
                                                          {/* =================== total row value ============== */}
                                                          <div className="row bg-info-20 py-1 px-0 m-0">
                                                            <div className="col-2 fs-14px fw-500 text-prime-100">
                                                              Total
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 m-0">
                                                              bla bla bla
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 text-success-100">
                                                              2,000,000,000.00
                                                            </div>
                                                          </div>
                                                        </div>
                                                      }
                                                    </div>
                                                  </Accordion.Body>
                                                </Accordion.Item>
                                              </Accordion>

                                              <Accordion
                                                activeKey={activeKeys}
                                                style={{ border: "0" }}
                                              >
                                                <Accordion.Item
                                                  eventKey="11"
                                                  style={{
                                                    borderRadius: "0",
                                                    border: "0",
                                                  }}
                                                >
                                                  <Accordion.Header
                                                    onClick={() =>
                                                      toggleAccordion("11")
                                                    }
                                                    // style={{
                                                    //   display: "flex",
                                                    //   justifyContent: "space-between",
                                                    //   alignItems: "center",
                                                    //   position: "relative",
                                                    //   borderRadius: "0",
                                                    //   padding:"0"
                                                    // }}
                                                  >
                                                    <div className="w-100 d-flex justify-content-between">
                                                      <span>
                                                        Budget Allocatoin
                                                      </span>
                                                      <span
                                                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                        style={{
                                                          height: "13.33px",
                                                          width: "13.33px",
                                                        }}
                                                      >
                                                        {activeKeys.includes(
                                                          "11"
                                                        )
                                                          ? "-"
                                                          : "+"}
                                                      </span>
                                                    </div>
                                                  </Accordion.Header>

                                                  <Accordion.Body>
                                                    <div>
                                                      {
                                                        <div className="row my-1 mx-0">
                                                          <div className="row m-0 px-0">
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Sr.
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Total Dept.
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Order No.
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Order Date
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Provision Budget
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Released Budget
                                                            </div>
                                                          </div>
                                                          <div className="row mt-1 m-0 px-0">
                                                            <div className="col-2 fs-14px fw-500">
                                                              Title here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              sr. here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 text-success-100">
                                                              2,000,000,000.00
                                                            </div>
                                                          </div>
                                                          <div className="row mt-1 m-0 px-0">
                                                            <div className="col-2 fs-14px fw-500">
                                                              Title here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              sr. here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 text-success-100">
                                                              2,000,000,000.00
                                                            </div>
                                                          </div>
                                                          {/* =================== total row value ============== */}
                                                          <div className="row bg-info-20 py-1 px-0 m-0">
                                                            <div className="col-2 fs-14px fw-500 text-prime-100">
                                                              Total
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 m-0">
                                                              bla bla bla
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 text-success-100">
                                                              2,000,000,000.00
                                                            </div>
                                                          </div>
                                                        </div>
                                                      }
                                                    </div>
                                                  </Accordion.Body>
                                                </Accordion.Item>
                                              </Accordion>

                                              <Accordion
                                                activeKey={activeKeys}
                                                style={{ border: "0" }}
                                              >
                                                <Accordion.Item
                                                  eventKey="100"
                                                  style={{
                                                    borderRadius: "0",
                                                    border: "0",
                                                  }}
                                                >
                                                  <Accordion.Header
                                                    onClick={() =>
                                                      toggleAccordion("100")
                                                    }
                                                    // style={{
                                                    //   display: "flex",
                                                    //   justifyContent: "space-between",
                                                    //   alignItems: "center",
                                                    //   position: "relative",
                                                    //   borderRadius: "0",
                                                    //   padding:"0"
                                                    // }}
                                                  >
                                                    <div className="w-100 d-flex justify-content-between">
                                                      <span>
                                                        Budget Repropregation
                                                      </span>
                                                      <span
                                                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                        style={{
                                                          height: "13.33px",
                                                          width: "13.33px",
                                                        }}
                                                      >
                                                        {activeKeys.includes(
                                                          "100"
                                                        )
                                                          ? "-"
                                                          : "+"}
                                                      </span>
                                                    </div>
                                                  </Accordion.Header>

                                                  <Accordion.Body>
                                                    <div>
                                                      {
                                                        <div className="row my-1 mx-0">
                                                          <div className="row m-0 px-0">
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Title
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Sr.
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Order No.
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Order Date
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Provision Budget
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Released Budget
                                                            </div>
                                                          </div>
                                                          <div className="row mt-1 m-0 px-0">
                                                            <div className="col-2 fs-14px fw-500">
                                                              Title here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              sr. here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 text-success-100">
                                                              2,000,000,000.00
                                                            </div>
                                                          </div>
                                                          <div className="row mt-1 m-0 px-0">
                                                            <div className="col-2 fs-14px fw-500">
                                                              Title here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              sr. here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 text-success-100">
                                                              2,000,000,000.00
                                                            </div>
                                                          </div>
                                                          {/* =================== total row value ============== */}
                                                          <div className="row bg-info-20 py-1 px-0 m-0">
                                                            <div className="col-2 fs-14px fw-500 text-prime-100">
                                                              Total
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 m-0">
                                                              bla bla bla
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 text-success-100">
                                                              2,000,000,000.00
                                                            </div>
                                                          </div>
                                                        </div>
                                                      }
                                                    </div>
                                                  </Accordion.Body>
                                                </Accordion.Item>
                                              </Accordion>

                                              <div className="row bg-info-20 py-1 px-0 m-0">
                                                <div className="col-2 fs-14px fw-500 text-prime-100">
                                                  Total
                                                </div>
                                                <div className="col-2 fs-14px fw-500 m-0">
                                                  bla bla bla
                                                </div>
                                                <div className="col-2 fs-14px fw-500">
                                                  2,000,000,000.00
                                                </div>
                                                <div className="col-2 fs-14px fw-500">
                                                  2,000,000,000.00
                                                </div>
                                                <div className="col-2 fs-14px fw-500">
                                                  2,000,000,000.00
                                                </div>
                                                <div className="col-2 fs-14px fw-500 text-success-100">
                                                  2,000,000,000.00
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div>
                                            <h3 className="fw-600 fs-18px my-2">
                                              Payment (Outflow)
                                            </h3>

                                            <div className=" py-1 d-flex flex-column gap-1 mt-2">
                                              <Accordion
                                                activeKey={activeKeys}
                                                style={{ border: "0" }}
                                              >
                                                <Accordion.Item
                                                  eventKey="101"
                                                  style={{
                                                    borderRadius: "0",
                                                    border: "0",
                                                  }}
                                                >
                                                  <Accordion.Header
                                                    onClick={() =>
                                                      toggleAccordion("101")
                                                    }
                                                    // style={{
                                                    //   display: "flex",
                                                    //   justifyContent: "space-between",
                                                    //   alignItems: "center",
                                                    //   position: "relative",
                                                    //   borderRadius: "0",
                                                    //   padding:"0"
                                                    // }}
                                                  >
                                                    <div className="w-100 d-flex justify-content-between">
                                                      <span>Vendor</span>
                                                      <span
                                                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                        style={{
                                                          height: "13.33px",
                                                          width: "13.33px",
                                                        }}
                                                      >
                                                        {activeKeys.includes(
                                                          "101"
                                                        )
                                                          ? "-"
                                                          : "+"}
                                                      </span>
                                                    </div>
                                                  </Accordion.Header>

                                                  <Accordion.Body>
                                                    <div>
                                                      {
                                                        <div className="row my-1 mx-0">
                                                          <div className="row m-0 px-0">
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Sr.
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Vendor
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Invoice / Date
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Sanctioned Order /
                                                              Date
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Invoice Amount
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Sanctioned Amount
                                                            </div>
                                                          </div>
                                                          <div className="row mt-1 m-0 px-0">
                                                            <div className="col-2 fs-14px fw-500">
                                                              Title here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              sr. here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                          </div>
                                                          <div className="row mt-1 m-0 px-0">
                                                            <div className="col-2 fs-14px fw-500">
                                                              Title here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              sr. here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 text-success-100">
                                                              2,000,000,000.00
                                                            </div>
                                                          </div>
                                                          {/* =================== total row value ============== */}
                                                          <div className="row bg-info-20 py-1 px-0 m-0">
                                                            <div className="col-2 fs-14px fw-500 text-prime-100">
                                                              Total
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 m-0">
                                                              bla bla bla
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 text-success-100">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 text-success-100">
                                                              2,000,000,000.00
                                                            </div>
                                                          </div>
                                                        </div>
                                                      }
                                                    </div>
                                                  </Accordion.Body>
                                                </Accordion.Item>
                                              </Accordion>

                                              <Accordion
                                                activeKey={activeKeys}
                                                style={{ border: "0" }}
                                              >
                                                <Accordion.Item
                                                  eventKey="102"
                                                  style={{
                                                    borderRadius: "0",
                                                    border: "0",
                                                  }}
                                                >
                                                  <Accordion.Header
                                                    onClick={() =>
                                                      toggleAccordion("102")
                                                    }
                                                    // style={{
                                                    //   display: "flex",
                                                    //   justifyContent: "space-between",
                                                    //   alignItems: "center",
                                                    //   position: "relative",
                                                    //   borderRadius: "0",
                                                    //   padding:"0"
                                                    // }}
                                                  >
                                                    <div className="w-100 d-flex justify-content-between">
                                                      <span>DBT/NACH</span>
                                                      <span
                                                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                        style={{
                                                          height: "13.33px",
                                                          width: "13.33px",
                                                        }}
                                                      >
                                                        {activeKeys.includes(
                                                          "102"
                                                        )
                                                          ? "-"
                                                          : "+"}
                                                      </span>
                                                    </div>
                                                  </Accordion.Header>

                                                  <Accordion.Body>
                                                    <div>
                                                      {
                                                        <div className="row my-1 mx-0">
                                                          <div className="row m-0 px-0">
                                                            <div className="col fs-12px text-black-60">
                                                              Sr.
                                                            </div>
                                                            <div className="col fs-12px text-black-60">
                                                              Department
                                                              Level/Name
                                                            </div>
                                                            <div className="col fs-12px text-black-60">
                                                              Scheme/Subhead
                                                              Code
                                                            </div>
                                                            <div className="col fs-12px text-black-60">
                                                              Order / Date
                                                            </div>
                                                            <div className="col fs-12px text-black-60">
                                                              Sanction Amount
                                                            </div>
                                                            <div className="col fs-12px text-black-60">
                                                              Deduction Amount
                                                            </div>
                                                            <div className="col fs-12px text-black-60">
                                                              Payment Amount
                                                            </div>
                                                          </div>

                                                          <div className="row mt-1 m-0 px-0">
                                                            <div className="col fs-14px fw-500">
                                                              Title here
                                                            </div>
                                                            <div className="col fs-14px fw-500">
                                                              sr. here
                                                            </div>
                                                            <div className="col fs-14px fw-500">
                                                              2,000
                                                            </div>
                                                            <div className="col fs-14px fw-500">
                                                              2,000
                                                            </div>
                                                            <div className="col fs-14px fw-500">
                                                              2,000
                                                            </div>
                                                            <div className="col fs-14px fw-500">
                                                              2,000
                                                            </div>
                                                            <div className="col fs-14px fw-500 text-success-100">
                                                              2,000
                                                            </div>
                                                          </div>
                                                          {/* =================== total row value ============== */}
                                                          <div className="row bg-info-20 py-1 px-0 m-0">
                                                            <div className="col fs-14px fw-500 text-prime-100">
                                                              Total
                                                            </div>
                                                            <div className="col fs-14px fw-500 m-0">
                                                              bla bla bla
                                                            </div>
                                                            <div className="col fs-14px fw-500">
                                                              2,000
                                                            </div>
                                                            <div className="col fs-14px fw-500">
                                                              2,000
                                                            </div>
                                                            <div className="col fs-14px fw-500">
                                                              2,000
                                                            </div>
                                                            <div className="col fs-14px fw-500">
                                                              2,000
                                                            </div>
                                                            <div className="col fs-14px fw-500">
                                                              2,000
                                                            </div>
                                                          </div>
                                                        </div>
                                                      }
                                                    </div>
                                                  </Accordion.Body>
                                                </Accordion.Item>
                                              </Accordion>

                                              <Accordion
                                                activeKey={activeKeys}
                                                style={{ border: "0" }}
                                              >
                                                <Accordion.Item
                                                  eventKey="103"
                                                  style={{
                                                    borderRadius: "0",
                                                    border: "0",
                                                  }}
                                                >
                                                  <Accordion.Header
                                                    onClick={() =>
                                                      toggleAccordion("103")
                                                    }
                                                    // style={{
                                                    //   display: "flex",
                                                    //   justifyContent: "space-between",
                                                    //   alignItems: "center",
                                                    //   position: "relative",
                                                    //   borderRadius: "0",
                                                    //   padding:"0"
                                                    // }}
                                                  >
                                                    <div className="w-100 d-flex justify-content-between">
                                                      <span>Salary</span>
                                                      <span
                                                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                        style={{
                                                          height: "13.33px",
                                                          width: "13.33px",
                                                        }}
                                                      >
                                                        {activeKeys.includes(
                                                          "103"
                                                        )
                                                          ? "-"
                                                          : "+"}
                                                      </span>
                                                    </div>
                                                  </Accordion.Header>

                                                  <Accordion.Body>
                                                    <div>
                                                      {
                                                        <div className="row my-1 mx-0">
                                                          <div className="row m-0 px-0">
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Title
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Sr.
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Order No.
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Order Date
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Provision Budget
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Released Budget
                                                            </div>
                                                          </div>
                                                          <div className="row mt-1 m-0 px-0">
                                                            <div className="col-2 fs-14px fw-500">
                                                              Title here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              sr. here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 text-success-100">
                                                              2,000,000,000.00
                                                            </div>
                                                          </div>
                                                          <div className="row mt-1 m-0 px-0">
                                                            <div className="col-2 fs-14px fw-500">
                                                              Title here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              sr. here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 text-success-100">
                                                              2,000,000,000.00
                                                            </div>
                                                          </div>
                                                          {/* =================== total row value ============== */}
                                                          <div className="row bg-info-20 py-1 px-0 m-0">
                                                            <div className="col-2 fs-14px fw-500 text-prime-100">
                                                              Total
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 m-0">
                                                              bla bla bla
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 text-success-100">
                                                              2,000,000,000.00
                                                            </div>
                                                          </div>
                                                        </div>
                                                      }
                                                    </div>
                                                  </Accordion.Body>
                                                </Accordion.Item>
                                              </Accordion>

                                              <Accordion
                                                activeKey={activeKeys}
                                                style={{ border: "0" }}
                                              >
                                                <Accordion.Item
                                                  eventKey="105"
                                                  style={{
                                                    borderRadius: "0",
                                                    border: "0",
                                                  }}
                                                >
                                                  <Accordion.Header
                                                    onClick={() =>
                                                      toggleAccordion("105")
                                                    }
                                                    // style={{
                                                    //   display: "flex",
                                                    //   justifyContent: "space-between",
                                                    //   alignItems: "center",
                                                    //   position: "relative",
                                                    //   borderRadius: "0",
                                                    //   padding:"0"
                                                    // }}
                                                  >
                                                    <div className="w-100 d-flex justify-content-between">
                                                      <span>
                                                        Budget Allocation
                                                      </span>
                                                      <span
                                                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                        style={{
                                                          height: "13.33px",
                                                          width: "13.33px",
                                                        }}
                                                      >
                                                        {activeKeys.includes(
                                                          "105"
                                                        )
                                                          ? "-"
                                                          : "+"}
                                                      </span>
                                                    </div>
                                                  </Accordion.Header>

                                                  <Accordion.Body>
                                                    <div>
                                                      {
                                                        <div className="row my-1 mx-0">
                                                          <div className="row m-0 px-0">
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Sr.
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Total Dept.
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Order No.
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Order Date
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Provision Budget
                                                            </div>
                                                            <div className="col-2 fs-12px text-black-60">
                                                              Released Budget
                                                            </div>
                                                          </div>
                                                          <div className="row mt-1 m-0 px-0">
                                                            <div className="col-2 fs-14px fw-500">
                                                              Title here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              sr. here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 text-success-100">
                                                              2,000,000,000.00
                                                            </div>
                                                          </div>
                                                          <div className="row mt-1 m-0 px-0">
                                                            <div className="col-2 fs-14px fw-500">
                                                              Title here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              sr. here
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 text-success-100">
                                                              2,000,000,000.00
                                                            </div>
                                                          </div>
                                                          {/* =================== total row value ============== */}
                                                          <div className="row bg-info-20 py-1 px-0 m-0">
                                                            <div className="col-2 fs-14px fw-500 text-prime-100">
                                                              Total
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 m-0">
                                                              bla bla bla
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500">
                                                              2,000,000,000.00
                                                            </div>
                                                            <div className="col-2 fs-14px fw-500 text-success-100">
                                                              2,000,000,000.00
                                                            </div>
                                                          </div>
                                                        </div>
                                                      }
                                                    </div>
                                                  </Accordion.Body>
                                                </Accordion.Item>
                                              </Accordion>

                                              <div className="row bg-info-20 py-1 px-0 m-0">
                                                <div className="col-2 fs-14px fw-500 text-prime-100">
                                                  Total
                                                </div>
                                                <div className="col-2 fs-14px fw-500 m-0">
                                                  bla bla bla
                                                </div>
                                                <div className="col-2 fs-14px fw-500">
                                                  2,000,000,000.00
                                                </div>
                                                <div className="col-2 fs-14px fw-500">
                                                  2,000,000,000.00
                                                </div>
                                                <div className="col-2 fs-14px fw-500">
                                                  2,000,000,000.00
                                                </div>
                                                <div className="col-2 fs-14px fw-500 text-success-100">
                                                  2,000,000,000.00
                                                </div>
                                              </div>
                                            </div>
                                            <div className="py-1 px-2 mx-0 bg-prime-100">
                                              <div className="fs-14px text-white m-0 d-flex justify-content-end align-items-center gap-2 py-2">
                                                <span className="fs-12px">
                                                  Receipt
                                                </span>{" "}
                                                50,00,000 <span>-</span>{" "}
                                                <span className="fs-12px">
                                                  Payment
                                                </span>{" "}
                                                25,00,000 <span>=</span>{" "}
                                                <span className="fs-12px">
                                                  Total
                                                </span>{" "}
                                                25,00,000
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}

export default SchemeLedgerOverlay;